import axios, { AxiosRequestHeaders } from 'axios';

//const API_USER = process.env.NX_API_USER;
//const API_PASS = process.env.NX_API_PASS;
//const SERVER_API = process.env.NX_SERVER_API;
const API_USER = "Eyezone"
const API_PASS = "Eyezone1234"
const SERVER_API = "https://api-il.traffilog.com/appengine_3/5E1DCD81-5138-4A35-B271-E33D71FFFFD9/1/json"

export const getPassword = (
  licenseNumber: string,
  isPrivate: string,
  identificationNumber: string,
  contactPhoneNumber: string,
  recipientPhoneNumber: string,
  recipientEmail: string
) => {
  const data = JSON.stringify({
    action: {
      name: 'generate_svr_identification_code',
      parameters: [
        {
          license_number: licenseNumber,
          is_private: isPrivate,
          identification_number: identificationNumber,
          contact_phone_number: contactPhoneNumber,
          recipient_phone_number: recipientPhoneNumber,
          recipient_email: recipientEmail,
        },
      ],
    },
  });

  return axios
    .post('/api', data, {
      auth: {
        username: API_USER || '',
        password: API_PASS || '',
      },
    })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.error('ERROR: ====', err.response!.status);
    });
};

export const getMessage = (id: string) => {
  const headers: AxiosRequestHeaders = {
    Authorization: 'Basic ' + btoa(API_USER + ':' + API_PASS),
    'Content-Type': 'application/json',
  };
  const data = JSON.stringify({
    action: {
      name: 'get_message',
      parameters: [
        {
          message_id: id,
          language: 'he',
        },
      ],
    },
  });
  return axios
    .post('/api', data, { headers: headers })
    .then((res) => {
      return decodeURIComponent(res.data.response.properties.data[0].message);
    })
    .catch((err) => {
      console.error('ERROR: ====', err);
    });
};

export const generateCertification = (
  code: string, 
  carNumber: string,
  phoneNumber: string,
  email: string,
  isGenerate: number
) => {
  const headers = new Headers();
  headers.set('Authorization', 'Basic ' + btoa(API_USER + ':' + API_PASS));
  headers.append('Content-Type', 'application/json');

  const data = JSON.stringify({
    action: {
      name: 'generate_svr_certification',
      parameters: [
        {
          license_number: carNumber,
          recipient_phone_number: phoneNumber,
          recipient_email: email,
          identification_code: code,
          is_generate_report: isGenerate,
        },
      ],
    },
  });
  return axios
    .post('/api', data, {
      auth: {
        username: API_USER || '',
        password: API_PASS || '',
      },
    })
    .then((res) => {
      return res.data.response;
    })
    .catch((err) => {
      console.error('ERROR: ====', err);
    });
};
